module.exports = __webpack_public_path__ + "static/media/superscript.b8828b3c.svg";